import React, { memo } from 'react';
import { createUseStyles, useTheme, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'BetaBadge');
const BetaBadge = /*#__PURE__*/memo(() => {
  const {
    t
  } = useWeb5Context();
  const theme = useTheme();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Text, {
    type: "badges",
    color: theme.colors.primary.white
  }, t('label_beta')));
});
export default BetaBadge;